import { render, staticRenderFns } from "./DeviceColorBar.vue?vue&type=template&id=a54ce8c4&scoped=true&"
import script from "./DeviceColorBar.vue?vue&type=script&lang=js&"
export * from "./DeviceColorBar.vue?vue&type=script&lang=js&"
import style0 from "./DeviceColorBar.vue?vue&type=style&index=0&id=a54ce8c4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a54ce8c4",
  null
  
)

export default component.exports